//
import ExtendModel from '@/models/ExtendModel'

/**
 * @class
 */
export default class PchProvider extends ExtendModel {
    /**
     *
     */
    static appends = ['branch_offices']

    /**
     *
     */
    static includes = ['pch_provider_branch_offices']

    /**
     *
     */
    get pch_provider_branch_offices_addresses() {
        return this.branch_offices.map(({ address }) => address)
    }

    /**
     * @description
     *
     */
    resource() {
        return 'pch_provider'
    }
}
